import Alert from '@mui/material/Alert';
import React from 'react';

interface Props {
  entityTitle: string;
}

export const EntityProposedOwnerWarning = ({ entityTitle }: Props) => {
  return (
    <Alert severity="info">
      {entityTitle} ownership has been proposed. Please confirm the owner by
      clicking on the "Confirm {entityTitle} Ownership" button below.
    </Alert>
  );
};
